export default "__VITE_ASSET__Bck1zEow__"